import pttLogo from '@/assets/images/providers/ptt.png';
import upsLogo from '@/assets/images/providers/ups.png';
import maerskLogo from '@/assets/images/providers/maersk.png';
import dhlLogo from '@/assets/images/providers/dhl.png';
import horozLogo from '@/assets/images/providers/horoz.png';
import heyworldLogo from '@/assets/images/providers/heyworld.png';
import imileLogo from '@/assets/images/providers/imile.png';
import fedexLogo from '@/assets/images/providers/fedex.png';
import quickshipperLogo from '@/assets/images/providers/quickshipper.png';
import springgdsLogo from '@/assets/images/providers/springgds.png';
import naqelLogo from '@/assets/images/providers/naqel.png';
import dhlexpressLogo from '@/assets/images/providers/dhlexpress.png';
import assetLogo from '@/assets/images/providers/asset.png';
import pts from '@/assets/images/providers/pts.png';
import boxGrayLogo from '@/assets/images/providers/box-gray.png';
import yurticiLogo from '@/assets/images/providers/yurtici-logo.png';
import suratLogo from '@/assets/images/providers/surat.png';
import arasLogo from '@/assets/images/providers/aras.png';

export const PROVIDERS = [
  {
    id: 1,
    name: 'Ptt',
    provider_code: 'Ptt',
    logo: pttLogo,
    pricing_type: 'kg_or_desi_min_max',
    currency: 'TRY',
    region_model_type: 1
  },
  {
    id: 2,
    name: 'Ups',
    provider_code: 'Ups',
    logo: upsLogo,
    pricing_type: 'kg_or_desi_min_max',
    currency: 'USD',
    region_model_type: 1
  },
  {
    id: 3,
    name: 'Maersk',
    provider_code: 'Maersk',
    logo: maerskLogo,
    pricing_type: 'kg_or_desi_min_max',
    currency: 'AOA',
    region_model_type: 1
  },
  {
    id: 4,
    name: 'Dhl',
    provider_code: 'Dhl',
    logo: dhlLogo,
    pricing_type: 'desi_piece',
    currency: 'USD',
    region_model_type: 1
  },
  {
    id: 5,
    name: 'Horoz',
    provider_code: 'Horoz',
    logo: horozLogo,
    pricing_type: 'kg_or_desi_min_max',
    currency: 'TRY',
    region_model_type: 1
  },
  {
    id: 6,
    name: 'Heyworld',
    provider_code: 'Heyworld',
    logo: heyworldLogo,
    pricing_type: 'desi_piece',
    currency: 'USD',
    region_model_type: 1
  },
  {
    id: 7,
    name: 'PttAbroad',
    provider_code: 'PttAbroad',
    logo: pttLogo,
    pricing_type: 'kg_or_desi_min_max',
    currency: 'USD',
    region_model_type: 1
  },
  {
    id: 8,
    name: 'Imile',
    provider_code: 'Imile',
    logo: imileLogo,
    pricing_type: 'desi_piece',
    currency: 'USD',
    region_model_type: 1
  },
  {
    id: 9,
    name: 'Fedex',
    provider_code: 'Fedex',
    logo: fedexLogo,
    pricing_type: 'kg_or_desi_min_max',
    currency: 'USD',
    region_model_type: 1
  },
  {
    id: 10,
    name: 'QuickShipper',
    provider_code: 'QuickShipper',
    logo: quickshipperLogo,
    pricing_type: 'desi_piece',
    currency: 'USD',
    region_model_type: 1
  },
  {
    id: 11,
    name: 'SpringGds',
    provider_code: 'SpringGds',
    logo: springgdsLogo,
    pricing_type: 'desi_piece',
    currency: 'USD',
    region_model_type: 1
  },
  {
    id: 12,
    name: 'Naqel',
    provider_code: 'Naqel',
    logo: naqelLogo,
    pricing_type: 'kg_or_desi_min_max',
    currency: 'TRY',
    region_model_type: 1
  },
  {
    id: 13,
    name: 'DhlExpress',
    provider_code: 'DhlExpress',
    logo: dhlexpressLogo,
    pricing_type: 'kg_or_desi_min_max',
    currency: 'EUR',
    region_model_type: 1
  },
  {
    id: 14,
    name: 'Nerka',
    provider_code: 'Nerka',
    logo: upsLogo,
    pricing_type: 'desi_piece',
    currency: 'USD',
    region_model_type: 1
  },
  {
    id: 15,
    name: 'Asset',
    provider_code: 'Asset',
    logo: assetLogo,
    pricing_type: 'kg_or_desi_min_max',
    currency: 'EUR',
    region_model_type: 1
  },
  {
    id: 16,
    name: 'Asset',
    provider_code: 'Asset',
    logo: assetLogo
  },
  {
    id: 17,
    name: 'Asset (UPS)',
    provider_code: 'Asset',
    logo: assetLogo
  },
  {
    id: 18,
    name: 'Pts',
    provider_code: 'Pts',
    logo: pts
  },
  {
    id: 19,
    name: 'Asset (DPD)',
    provider_code: 'Asset',
    logo: assetLogo
  },
  {
    id: 20,
    name: 'YurticiKargo',
    provider_code: 'YurticiKargo',
    logo: yurticiLogo
  },
  {
    id: 21,
    name: 'SuratKargo',
    provider_code: 'SuratKargo',
    logo: suratLogo
  },
  {
    id: 22,
    name: 'ArasKargo',
    provider_code: 'ArasKargo',
    logo: arasLogo
  }
];

export const getProvider = provider => {
  const providerCode = provider?.provider_code || provider?.providerCode || provider;
  const providerId = provider?.id || provider;

  return (
    PROVIDERS.find(
      p =>
        p.provider_code &&
        providerCode &&
        String(p.provider_code).toLowerCase() === String(providerCode).toLowerCase()
    ) || PROVIDERS.find(p => p.id === providerId)
  );
};

export const getProviderLogo = provider => {
  const matchedProvider = getProvider(provider);
  return matchedProvider && matchedProvider.logo ? matchedProvider.logo : boxGrayLogo;
};
